import React from 'react'

class Expired extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      detail: props.detail
    }
  }
  render () {
    return (
      <section className='section' style={{ width: '70vw' }}>
        <header className='title-block'>
          <h1 className='title'>Expired Attractions List</h1>
        </header>
        <div className='form-group row'>
          <div className='col-3'>
            <label className='control-label'>Expired ID</label>
          </div>
          <div className='col-9'>
            {
              this.props.detail.length > 0
                ? this.props.detail.map((item, i) => (
                  <span className='badge badge-info mr-2' key={i}>{item.id}</span>
                ))
                : <span className='badge badge-danger'>- No Expired ID -</span>
            }
          </div>
        </div>
        <div className='row'>
          <div className='col-12 text-right'>
            <button className='btn btn-secondary' onClick={() => this.props.closeModal()}>Close</button>
          </div>
        </div>
      </section>
    )
  }
}

export default Expired



// WEBPACK FOOTER //
// ./src/Containers/CronReport/Expired.js